import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as estimate from '../estimate'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: estimate.RESOURCE.payload.dimension.partialId,
      partialId: estimate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Category of people for which this FTE estimate applies',
    isOptional: false,
    name: 'Library User Category',
    partialId: PartialId.Standard.create('lib_usr_cat'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.libraryUserCategory.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
